var exports = {
  "successIsPrimary": "successIsPrimary__fhahjv",
  "success": "success__p68Dha",
  "neutral": "neutral__137xbc",
  "attention": "attention__ra2-IC",
  "danger": "danger__tHIzJt",
  "done": "done__1aYaW5",
};

__webpack_require__.r(module.exports = exports);
